module.exports = __webpack_public_path__ + "media/images/icon__plus@3x-0d5e52e08780d3e9dcf67ede383ec93c.png";